import React, { useCallback, useState } from 'react'
import { intl } from 'lang/intl'

import { useJoinToSpeakAsHost } from '../../../../join-to-speak'
import { useWebinarColors } from '../../../../hooks/useWebinarColors'
import Button from '../../../../components/ButtonComponent/ButtonComponent'

import './attendee-demoter.scss'

type AttendeeDemoterProps = {
  attendeeId: string
  attendeeName: string
}

const AttendeeDemoter = ({
  attendeeId,
  attendeeName,
}: AttendeeDemoterProps) => {
  const { handleAttendeeExpiration } = useJoinToSpeakAsHost()
  const [isDisabled, setIsDisabled] = useState(false)
  const webinarColors = useWebinarColors()

  const onClick = useCallback(async () => {
    setIsDisabled(true)
    await handleAttendeeExpiration(attendeeId)
  }, [attendeeId, handleAttendeeExpiration])

  return (
    <div className="attendee-demoter">
      <Button
        size="small"
        color="themed"
        style={{
          color: webinarColors.accent.contrast,
          backgroundColor: webinarColors.accent,
        }}
        ariaLabel={intl.formatMessage(
          {
            defaultMessage: 'Send {name} back to the audience',
          },
          { name: attendeeName }
        )}
        disabled={isDisabled}
        onClick={onClick}
      >
        {!isDisabled
          ? intl.formatMessage({
              defaultMessage: 'Remove',
            })
          : intl.formatMessage({
              defaultMessage: 'Removing...',
            })}
      </Button>
    </div>
  )
}

export { AttendeeDemoter }
